import React from 'react';
import { signOutUser } from '../../services/auth';
import HandoffShell, { HandoffLink } from './HandoffShell';
import HandoffWaveform from './HandoffWaveform';
import HandoffLoading from './HandoffLoading';

export type HandoffStatus = 'pending' | 'success' | 'error';

interface AuthHandoffStatusProps {
    status: HandoffStatus;
}

// Shown on /callback?nonce=... after the user authenticates in the browser:
// the page exists only to hand the session off to the plugin, so it never
// renders the full app. Presentational only — AuthGate owns the handoff and
// passes the resulting status in.
function AuthHandoffStatus({ status }: AuthHandoffStatusProps) {
    if (status === 'success') {
        return (
            <HandoffShell
                waveform={<HandoffWaveform mode="success" />}
                label="You're signed in!"
                detail="You can close this page and return to the plugin."
                action={<HandoffLink onClick={() => signOutUser()}>Sign out</HandoffLink>}
            />
        );
    }

    if (status === 'error') {
        return (
            <HandoffShell
                label="Something went wrong"
                detail="Return to the plugin and try logging in again."
                action={<HandoffLink onClick={() => window.location.reload()}>Try again</HandoffLink>}
            />
        );
    }

    return <HandoffLoading label="Signing you in" detail="Connecting the plugin to your account." />;
}

export default AuthHandoffStatus;
